import React, { useContext } from 'react';

export const Context = React.createContext();

export default function useProductListViewed() {
  return useContext(Context);
}
